/**
 * Created by FangShenglong at 2019/12/07
 */
import axios from "axios";
import router from "@src/common/router";
import store from "@src/common/lib/store";
import i18n from "@src/common/lib/i18n";
import log from "@src/common/utils/log";
import config from "@src/common/config";
import ignoreApi from "@src/common/api/ignore";
import {
  Message
} from "element-ui";
import {
  Cache,
  Log
} from "$utils";
import NProgress from "nprogress";
NProgress.configure({
  showSpinner: false
})

// 将所有的批次请求放入一个全局列表中，当页面发生跳转时，将所有未完成的请求取消掉
window.axiosPromiseArr = [];
window.axiosKeyArr = [];
// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true;
// Add a request interceptor
axios.interceptors.request.use(
  (axiosConfig) => {
    NProgress.start();
    const configKey = axiosConfig.url + "_" + new Date().getTime();
    axiosConfig.cancelToken = new axios.CancelToken((cancel) => {
      window.axiosPromiseArr.push({
        cancel
      });
      window.axiosKeyArr.push(configKey);
    });
    axiosConfig.configKey = configKey;
    return axiosConfig;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 当用户会话超时，返回一个空的对象，避免页面出现错误提示
let httpNull = {
  msgCode: "0",
  msgContent: "",
  page: null,
  returnObj: null,
  success: true
};

// 当系统出现错误请求失败时，统一返回该提示消息给接口调用处的方法
const httpError = {
  msgCode: "-1",
  msgContent: i18n.t("system.common.message.systemerror"),
  page: null,
  returnObj: null,
  success: false
};

/**
 * [getMockUrl 根据系统配置，获取接口地址URL，如果系统配置为启动模拟桩请求，则直接封装为模拟桩请求的URL地址]
 * @param  {[String]} url [原始URL]
 * @return {[String]}     [封装后的URL]
 */
function getMockUrl(url) {
  // 如果请求的为接口绝对地址（以http://或者https://开头），则直接不进行封装
  if (!url || url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
    return url + "";
  }
  // 如果系统配置为支持获取模拟桩接口数据，则开始封装模拟桩接口地址
  if (window.systemConfig.MOCK_SERVER.SWITCH) {
    let serverUrl = window.systemConfig.MOCK_SERVER.SERVER_URL;
    // 如果未配置模拟桩服务器地址，则获取当前服务器地址为模拟桩服务器
    if (
      !serverUrl ||
      !serverUrl.trim().length ||
      (serverUrl.indexOf("http://") !== 0 &&
        serverUrl.indexOf("https://") !== 0)
    ) {
      serverUrl = location.href.split("/#/")[0];
    }
    let mockServer = serverUrl + "/mock/";
    let version = window.systemConfig.MOCK_SERVER.VERSION || "base";
    mockServer += version;
    url = mockServer + url;
  }
  return url;
}

function getMockData(url, callback) {
  axios.get(url).then(
    (response) => {
      if (callback && typeof callback === "function") {
        callback(response.data);
      }
    },
    () => {
      log.error("模拟数据请求失败！当前接口地址为：", url);
    }
  );
}

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // 请求响应完成后，将当当前对应的请求全局保存的信息从axiosKeyArr和axiosPromiseArr中移除
    const reqIndex = window.axiosKeyArr.indexOf(response.config.configKey);
    window.axiosKeyArr.splice(reqIndex, 1);
    window.axiosPromiseArr.splice(reqIndex, 1);
    NProgress.done();
    // Do something with response data
    // 接口请求成功后，判断当前用户会话是否超时，200表示http码为200，请求成功
    if (response.status === 200) {
      // JSON.parse如果不报错则是Json对象，报错则是文件流
      let enc = new TextDecoder("utf-8");
      let resBuffer = "";
      try {
        // 文件流下载的时候返回的JSON对象响应体会被转化为数据流
        resBuffer = JSON.parse(enc.decode(new Uint8Array(response.data))); //转化成json对象
        if (resBuffer.needLogin !== undefined && !!resBuffer.needLogin) {
          store.dispatch("clearUserCache");
          router.push({
            path: config.LOGIN_PAGE
          });
          response.data = httpNull;
          return response;
        }
      } catch {
        //
      }
      // 如果needLogin为true，表示用户会话超，需要跳转至用户登录页面
      if (response.data.needLogin !== undefined && !!response.data.needLogin) {
        log.error(
          "用户会话超时，需重新登录！当前接口地址为：",
          response.config.url
        );
        // 页面跳转前，清空所有用户相关信息
        store.dispatch("clearUserCache");
        // 如果响应结果中带有跳转地址，则跳转至响应结果中的地址，否则跳转至当前系统中默认的登录页面
        if (response.data.location) {
          window.location.href = response.data.location;
        } else {
          router.push({
            path: config.LOGIN_PAGE
          });
        }
        response.data = httpNull;
      }
      // 如果licence文件失效过期,跳转上传licence页面
      if (response.data.licence === false) {
        log.error("licence文件失效过期：");
        if (response.data.licenceDescription === "licencedate") {
          // Message({ type: 'error', message: '证书过期，请重新上传证书' })
          // response.data.msgContent = '证书过期，请重新上传证书'
          router.push({
            path: config.LICENCE,
            query: {
              message: "证书过期，请重新上传证书"
            }
          });
        } else {
          // Message({ type: 'error', message: '证书无效，请重新上传证书' })
          // response.data.msgContent = '证书无效，请重新上传证书'
          router.push({
            path: config.LICENCE,
            query: {
              message: "证书无效，请重新上传证书"
            }
          });
        }
      }
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    // Do something with response error
    // 请求失败，执行请求失败的函数reject
    return Promise.reject(error);
  }
);
export function fetchVideo(url, param, axiosConfig) {
  return new Promise((resolve) => {
    axios
      .post(url, param && param)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          // 所有请求失败也执行resolve方法，封装统一的错误消息给业务接口调用处
          // 只有当存在返回消息时，才返回错误消息
          if (err.message) {
            log.error(
              "fetch接口请求失败，请求url为：",
              url,
              "；请求参数为：",
              param,
              "；错误消息为：",
              err
            );
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetch接口请求失败，请求url为：",
          url,
          "；请求参数为：",
          param,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  })
}

// let filterRESTful = ['getDeptAndCameraByParentTm.json', 'myLogin.json', 'addPlanInfo.json', 'getGroupAndUserList.json', 'getGrounpByCenterId.json', 'getCamera.json', 'issPlatQueryUpdate.json', 'issPlatAdd.json', 'getVcm.json', 'delVcm.json', 'modifyVcm.json', 'updateCameraGrounpName.json', 'getPatrolRouteListByCenterId.json'];
export default function fetch(url, param, axiosConfig) {
  // console.log(axiosConfig, 'axiosConfig')
  if (!url || !url.trim().length) {
    log.error("fetch请求接口地址为空，终止请求");
    return new Promise((resolve) => {
      resolve(httpError);
    });
  }
  axiosConfig = axiosConfig || {};
  if (store.getters.userInfo !== null && store.getters.userInfo !== undefined) {
    axiosConfig.headers = {
      ticket: store.getters.userInfo.access_token || "",
      // 'ticket': "93f1e487-b68d-4312-a5dc-873722da8632" || '',
      locale: i18n.locale || "",
    };

    if (url.indexOf('VIID') > 0) {
      delete axiosConfig.headers.ticket;
      delete axiosConfig.headers.locale;
      axiosConfig.headers.Authorization = window.token;
      axiosConfig.headers['Content-Type'] = 'application/json'
      // console.log(axiosConfig, axiosConfig.headers.Authorization, window.token, '====axiosConfig')
    }
  }
  param = param || {};

  const account = Cache.get("CACHE_USER_INFO");
  const ignorePark = ignoreApi.ignorePark;
  const targetList = url.split("/");
  if (
    ignorePark.indexOf(targetList[targetList.length - 1].split(".")[0]) ===
    -1 &&
    account &&
    account.parkId
  ) {
    param.parkId = account.parkId;
  }
  return new Promise((resolve) => {
    url = getMockUrl(url);
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return getMockData(url, resolve);
    }
    // 临时修改方案，在此处判断接口是否是获取视频播放地址
    if (
      url.indexOf("vas/video/queryRealTimeVideoRtsp.json") !== -1 ||
      url.indexOf("vas/video/queryPlayBackVideoRtsp.json") !== -1
    ) {
      if (!param.pushMode) {
        // param.pushMode = store.getters.networkType || 'CLOUD';
        param.pushMode = "CLOUD";
      }
    }
    if (targetList[1] == 'VIID') {
      delete param.parkId
      // if (!param.UserName) {
      //   param = null
      // }


    }
    axios
      .post(url, param && param, axiosConfig)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          // 所有请求失败也执行resolve方法，封装统一的错误消息给业务接口调用处
          // 只有当存在返回消息时，才返回错误消息
          if (err.message) {
            log.error(
              "fetch接口请求失败，请求url为：",
              url,
              "；请求参数为：",
              param,
              "；错误消息为：",
              err
            );
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetch接口请求失败，请求url为：",
          url,
          "；请求参数为：",
          param,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  });
}

const loginObj = {
  url: '/auth/login',
  param: {
    "grant_type": "password",  		// 授权类型，固定值：password，长度(0,128)
    "username": "test",		  		// 用户名，长度(0,50)
    "password": "H191Hz69qz2nG+zUFPPINPHVdfKhkWVJFyynn5wnSJGODElxUvIes3Ii579/vofjpwmgaCPPiCwdOkEc20dWrU9aqEeZlJRYKgOnMwyaElv2OyQ1vdY4Ki+ELdXtUaTaCOo51p+9TrM3dRKlGH+dfBsBOcPr6+56HOgz+MRDzb0=",				   		// 平台密码，需RSA加密密码传输,RSA公钥获取公钥接口，加密参考：RSA加密demo，长度(0,255)
    "client_id": "web_client", 		// 凭证id，自定义，建议数字、字母，长度(0,128)
    "client_secret": "web_client",	// 凭证密钥，访问凭证client_id与client_secret必须和在ICC平台上申请的client_id与client_secret保持一致，详见申请访问凭证获取，长度(0,128)
  },
  axiosConfig: {}
}

export const fetchDaHua = async (url, param, axiosConfig = {}, needLogin = true, needUserInfo = true) => {
  // console.log(axiosConfig, 'axiosConfig')
  if (!url || !url.trim().length) {
    log.error("fetch请求接口地址为空，终止请求");
    return new Promise((resolve) => {
      resolve(httpError);
    });
  }
  axiosConfig = axiosConfig || {};
  if (store.getters.userInfo !== null && store.getters.userInfo !== undefined && needUserInfo) {
    axiosConfig.headers = {
      ticket: store.getters.userInfo.access_token || "",
      // 'ticket': "93f1e487-b68d-4312-a5dc-873722da8632" || '',
      locale: i18n.locale || "",
    };

    if (url.indexOf('VIID') > 0) {
      delete axiosConfig.headers.ticket;
      delete axiosConfig.headers.locale;
      axiosConfig.headers.Authorization = window.token;
      axiosConfig.headers['Content-Type'] = 'application/json'
      // console.log(axiosConfig, axiosConfig.headers.Authorization, window.token, '====axiosConfig')
    }
  }
  param = param || {};

  if (isDaHua) {
    let result = await fetchDaHua(loginObj.url, loginObj.param, undefined, false, false)
    if (result.msgCode && result.msgCode === '0' && result.returnObj.data) {
      param['accessToken'] = '1:ea42ee81-53d6-4631-a02a-c2c4400886ea'
    } else {
      log.error("登陆失败");
      return new Promise((resolve) => {
        resolve(httpError);
      });
    }
  }

  const account = Cache.get("CACHE_USER_INFO");
  const ignorePark = ignoreApi.ignorePark;
  const targetList = url.split("/");
  if (
    ignorePark.indexOf(targetList[targetList.length - 1].split(".")[0]) ===
    -1 &&
    account &&
    account.parkId
  ) {
    param.parkId = account.parkId;
  }
  return new Promise((resolve) => {
    url = getMockUrl(url);
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return getMockData(url, resolve);
    }
    // 临时修改方案，在此处判断接口是否是获取视频播放地址
    if (
      url.indexOf("vas/video/queryRealTimeVideoRtsp.json") !== -1 ||
      url.indexOf("vas/video/queryPlayBackVideoRtsp.json") !== -1
    ) {
      if (!param.pushMode) {
        // param.pushMode = store.getters.networkType || 'CLOUD';
        param.pushMode = "CLOUD";
      }
    }
    if (targetList[1] == 'VIID') {
      delete param.parkId
      // if (!param.UserName) {
      //   param = null
      // }


    }
    axios
      .post(url, param && param, axiosConfig)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          // 所有请求失败也执行resolve方法，封装统一的错误消息给业务接口调用处
          // 只有当存在返回消息时，才返回错误消息
          if (err.message) {
            log.error(
              "fetch接口请求失败，请求url为：",
              url,
              "；请求参数为：",
              param,
              "；错误消息为：",
              err
            );
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetch接口请求失败，请求url为：",
          url,
          "；请求参数为：",
          param,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  });
}



export function fetchGet(url, axiosConfig) {
  if (!url || !url.trim().length) {
    log.error("fetchGet请求接口地址为空，终止请求");
    return new Promise((resolve) => {
      resolve(httpError);
    });
  }
  axiosConfig = axiosConfig || {};
  if (store.getters.userInfo !== null && store.getters.userInfo !== undefined) {
    axiosConfig.headers = {
      ticket: store.getters.userInfo.ticket || ""
    };
  }
  return new Promise((resolve) => {
    url = getMockUrl(url);
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return getMockData(url, resolve);
    }
    axios
      .get(url, axiosConfig)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          log.error(
            "fetchGet接口请求失败，请求url为：",
            url,
            "；错误消息为：",
            err
          );
          if (err.message) {
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetchGet接口请求失败，请求url为：",
          url,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  });
}

export function fetchDelete(url, axiosConfig) {
  if (!url || !url.trim().length) {
    log.error("fetchDelete请求接口地址为空，终止请求");
    return new Promise((resolve) => {
      resolve(httpError);
    });
  }
  axiosConfig = axiosConfig || {};
  if (store.getters.userInfo !== null && store.getters.userInfo !== undefined) {
    axiosConfig.headers = {
      ticket: store.getters.userInfo.ticket || ""
    };
  }
  return new Promise((resolve) => {
    url = getMockUrl(url);
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return getMockData(url, resolve);
    }
    axios
      .delete(url, axiosConfig)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          log.error(
            "fetchDelete接口请求失败，请求url为：",
            url,
            "；错误消息为：",
            err
          );
          if (err.message) {
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetchDelete接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetchDelete接口请求失败，请求url为：",
          url,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetchDelete接口请求被取消，请求url为：", url);
        }
      });
  });
}

export function fetchDownLoad(url, param, configParam) {
  let _config = configParam || {};
  let userInfo = Cache.get("CACHE_USER_INFO");
  if (userInfo && userInfo.access_token) {
    _config.headers = {
      ticket: userInfo.access_token,
      locale: i18n.locale || ""
    };
  } else {
    _config.headers = {
      locale: i18n.locale || ""
    };
  }
  let _param = param || {};
  return new Promise((resolve) => {
    axios
      .post(url, _param, _config)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          if (err.message) {
            Log.error(
              "fetch接口请求失败，请求url为：",
              url,
              "；请求参数为：",
              _param,
              "；错误消息为：",
              err
            );
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            Log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        Log.error(
          "fetch接口请求失败，请求url为：",
          url,
          "；请求参数为：",
          _param,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          Log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  });
}

export function fetchForm(url, param) {
  if (!url || !url.trim().length) {
    log.error("fetchForm请求接口地址为空，终止请求");
    return new Promise((resolve) => {
      resolve(httpError);
    });
  }
  let axiosConfig = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      locale: i18n.locale || ""
    }
  };
  if (store.getters.userInfo !== null && store.getters.userInfo !== undefined) {
    axiosConfig.headers.ticket = store.getters.userInfo.ticket || "";
  }
  return new Promise((resolve) => {
    url = getMockUrl(url);
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return getMockData(url, resolve);
    }
    axios
      .post(url, param, axiosConfig)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          log.error(
            "fetchForm接口请求失败，请求url为：",
            url,
            "；请求参数为：",
            param,
            "；错误消息为：",
            err
          );
          if (err.message) {
            resolve(httpError);
          } else {
            // 如message为空，则表示当前请求被取消，不需要进行返回
            log.info("fetch接口请求被取消，请求url为：", url);
          }
        }
      )
      .catch((err) => {
        log.error(
          "fetchForm接口请求失败，请求url为：",
          url,
          "；请求参数为：",
          param,
          "；错误消息为：",
          err
        );
        if (err.message) {
          resolve(httpError);
        } else {
          // 如message为空，则表示当前请求被取消，不需要进行返回
          log.info("fetch接口请求被取消，请求url为：", url);
        }
      });
  });
}
